// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-38ed449c] .el-transfer .el-transfer-panel__body,[data-v-38ed449c] .el-transfer .el-transfer-panel__list {\n  height: 350px;\n}", ""]);
// Exports
module.exports = exports;
